import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { I18NextPipe } from 'angular-i18next';
import * as _ from 'lodash';
import { DialogDateFiltersComponent } from 'src/app/common/dialogs/dialog-date-filters/dialog-date-filters.component';
import { DialogDownloadTableComponent } from "src/app/common/dialogs/dialog-download-table/dialog-download-table.component";
import { State } from 'src/app/dashboards/state';
import { dataSourceType, widgetComponentType, widgetType } from 'src/app/enums';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import { BaseReportsDetailsComponent } from '../base/base-reports-details.component';

@Component({
  selector: 'app-pcc-reports-details',
  templateUrl: './pcc-reports-details.component.html',
  styleUrls: [
    '../base/base-reports-details.component.scss',
    './pcc-reports-details.component.scss'
  ],
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate('200ms ease-in')),
      transition('true => false', animate('200ms ease-out'))
    ])
  ],
  standalone: false
})

export class PccReportsDetailsComponent extends BaseReportsDetailsComponent {

  public secondDownloadButtonEnabled: boolean = false; // Unleash feature flag 

  constructor(protected dashboardsService: DashboardService, protected i18nextPipe: I18NextPipe, public dialog: MatDialog, protected store: Store<State>) {
    super(dashboardsService, i18nextPipe, dialog, store);
  }

  loadReportData(reportId, subReportId) {
    this.showReport = false;
    this.dataLoaded = false;
    this.showColumnOrder = false;
    this.showColumnButton = false;
    this.resetGridItem(reportId, subReportId);
    this.dashboardsService.getReport(reportId, subReportId).subscribe(report => {
      this.dataLoaded = true;
      //this.rdp_data = { value: -1, selectedRange: 0 };
      this.report = report;
      if (report.preset) {
        this.gridItem.setup = { ...this.gridItem.setup, ...report.preset };
        this.gridItem.type = report.preset.reportType;
      }
      this.gridItem.setup.subReportId = report.subReportId;

      if (!this.isFromDashboard) {
        let allColumns = report.allColumns.map(c => c.labelCode);
        this.gridItem.setup.columns = report.rawColumns?.filter(c => c && allColumns.includes(c)) ?? [];
      }

      let ServiceNum = report.parameters.find(r => r.name == 'ServiceNum');
      let sysGroupByTime = report.parameters.find(r => r.name == 'sysGroupByTime');

      this.sysShowEmpty = report.parameters.find(r => r.name == 'sysShowEmpty' && r.promptUser);
      this.sysAgentNoCalls = report.parameters.find(r => r.name == 'sysAgentNoCalls');
      let sysDimsForFilter = report.parameters.find(r => r.name == 'sysDimsForFilter');

      this.serviceNumbers = ServiceNum ? ServiceNum.customParameters : [];
      this.sysGroupByTime = sysGroupByTime ? sysGroupByTime.customParameters : [];
      this.columns = report.allColumns.sort((a, b) => Number(b.isKey) - Number(a.isKey) || a.order - b.order);
      if (!this.isFromDashboard) {
        this.defaultColumns = report.defaultColumns.filter(x => !report.allColumns.find(c => c.labelCode === x)?.isKey);
      }

      if (!sysGroupByTime) {
        delete this.gridItem.setup.sysGroupByTime;
      }

      if (this.gridItem.setup.period.from || typeof this.gridItem.setup.period.from === 'string' || this.gridItem.setup.period.from instanceof String) {
        this.gridItem.setup.period.from = new Date(<string>this.gridItem.setup.period.from);
      }

      if (this.gridItem.setup.period.to || typeof this.gridItem.setup.period.to === 'string' || this.gridItem.setup.period.to instanceof String) {
        this.gridItem.setup.period.to = new Date(<string>this.gridItem.setup.period.to);
      }

      if (this.serviceNumbers?.length > 0 && this.gridItem.setup.serviceNumber == null) {
        let sn = this.serviceNumbers.find(s => s.defaultValue == 1)?.key;

        if (!sn && this.serviceNumbers.length == 1) {
          sn = this.serviceNumbers[0].key;
        }
        else if (!sn) {
          sn = this.serviceNumbers.find(s => s.key == ServiceNum.defaultValue?.split("#").pop())?.key;
        }

        if (!sn) {
          sn = this.serviceNumbers[0].key;
        }

        this.gridItem.setup.serviceNumber = sn;
      }

      this.sysDimsForFilter = (sysDimsForFilter?.sysDimsForFilter || sysDimsForFilter?.value || '').split(',').filter(f => f != '');

      if (this.sysDimsForFilter.indexOf('N') > -1) {
        this.dashboardsService.getReportRowsFilter('N', '').subscribe(n => this.accesspoints = n.map(m => ({ ...m, description: `${m.accesspoint}_${m.description}` })));
      }

      if (!this.gridItem.setup.limitRange) {
        this.gridItem.setup.filters = {};
      }
      this.setInitialSetup();
      setTimeout(() => {
        this.initialSetup.columns = _.cloneDeep(this.gridItem.setup.columns);
        this.notifyReportModified();
      }, 100);
      this.reportModifiedNotifier.emit(false);
      this.page.basicExpanded = false;
      this.page.settingsExpanded = false;
      this.page.infoAllColumns = false;
      this.reportLoaded = true;
      this.reportLoadedNotifier.emit(true);
    });
  }

  resetGridItem(reportId, subReportId) {
    this.gridItem = {
      cols: 6, rows: 6, x: 0, y: 0,
      componentType: widgetComponentType.Reports,
      colorScheme: 2,
      dataSourceType: dataSourceType.Realtime,
      type: widgetType.Table,
      setup: {
        period: { type: 0 },
        sysGroupByTime: ' ',
        limitRange: false,
        reportId,
        subReportId,
        filters: {}
      }
    }
  }

  modelChange() {
    let setup = this.gridItem.setup;
    let isCompleted = true;

    var keyColumns = this.columns?.filter(c => c.isKey).map(c => c.labelCode) || [];

    var isValidForChart: boolean = !this.report.disableCharts;
    if (!setup.columns || setup.columns.length > keyColumns.length + 4) isValidForChart = false;
    // var types = [...new Set(setup.columns?.filter(f => keyColumns.indexOf(f) < 0).map(c => this.columns.find(f => f.labelCode == c)?.dbType))] || [];
    const types = [
      ...new Set(
        (setup.columns ?? [])
          .filter(f => keyColumns.indexOf(f) < 0)
          .map(c => this.columns.find(f => f.labelCode === c)?.dbType)
      )
    ];
    if (types.length > 1 || types.indexOf(7) < 0) isValidForChart = false;

    if (setup.columns && !isValidForChart) {
      this.visualTypeDisabledItems = [0, 1, 2, 3];
    } else {
      this.visualTypeDisabledItems = [3];
    }

    if (this.columns?.length > 0 && this.visualTypeDisabledItems.indexOf(this.gridItem.type) > -1) {
      this.gridItem.type = widgetType.Table;
    }

    if (this.serviceNumbers?.length > 0 && !setup.serviceNumber) isCompleted = false;
    if (!setup.columns || setup.columns.length < keyColumns.length + 1) isCompleted = false;

    if (setup.period?.type == 0 && (!setup.period.from || !setup.period.to)) isCompleted = false;
    this.isSetupCompleted = isCompleted;
    this.notifyReportModified();
  }

  selectModelChange($event, modelName) {
    this.gridItem.setup[modelName] = $event;
    this.modelChange();
  }

  showLimitTimeRange() {
    const dialogRef = this.dialog.open(DialogDateFiltersComponent, {
      data: { gridItem: this.gridItem },
      panelClass: 'dialog-standard-pannel',
      backdropClass: "backdrop-invisible",
      width: "400px",
      height: "640px",
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        this.gridItem.setup.filters = Object.assign({}, data.filters);
      }
    });
  }

  isTimeRangeVisible(): boolean {
    let hiddenReports = ["AgentIdIO", "MaxMinAvg", "AgentPause"];
    if (hiddenReports.indexOf(this.report["report_Code"]) > -1) return false;
    return true;
  }

  viewReport() {
    this.showReport = true;
    this.dataEquality = !this.dataEquality;
    this.generateNotifier$.next();
    this.reportFullscreen();

    this.dashboardsService.getSecondDownloadButtonFeatureFlag().subscribe(
      secondDownloadButtonEnabled =>
        this.secondDownloadButtonEnabled = secondDownloadButtonEnabled
    );
  }

  setPeriod(newPeriod) {
    this.gridItem.setup.period = newPeriod;
  }

  openDownloadDialog() {
    this.downloadDialogNotifier$.next();
  }

  filtersLengthIsEven() {
    if (["AgentId", "AgentGroup", "AgentQ", "AgentSMS", "MaxMinAvg"].includes(this.report["report_Code"])) return false;
    if (this.report["report_Code"] === "QDetails" || this.report["report_Code"] === "QDetailsAll") return true;
    return this.sysDimsForFilter.length % 2 === 0 ? true : false;
  }

  // for testing purposes - handler for "Download Report 2" button
  exportTable2() {
    const dialogRef = this.dialog.open(DialogDownloadTableComponent, {
      panelClass: 'dialog-standard-pannel',
      backdropClass: "backdrop-invisible",
      data: {
        fileName: (this.report as any).report_Code,
        reportCode: (this.report as any).report_Code,
        fileType: "XLSX",
        fileTypes: ["XLSX", "CSV (Comma Delimmited)"],
        isChart: false
      },
      width: "495px",
      height: "305px"
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data) {

        let fileName: string = data.fileName;
        let fileType: string = data.fileType;
        let isTotalChecked: boolean = data.isTotalChecked;
        let reportTitle: string = this.report?.shortDescription;

        //let model = {
        //  data: [...exportData],
        //  exportColumns: exportColumns,
        //  reportInfo: this.reportInfo,
        //  reportTitle: reportTitle
        //};

        //if (fileType.toLowerCase() !== "xlsx" && model.data.filter(i => i["Agent ID"] === "Total").length > 0) {
        //  model.data = model.data.filter(i => i["Agent ID"] !== "Total");
        //}

        this.dashboardsService.ExportReportToFile(this.gridItem.setup, reportTitle, fileType, isTotalChecked).subscribe(blob => {
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");

          link.href = blobUrl;
          link.download = fileType.toLowerCase() === "xlsx" ? `${fileName}.xlsx` : `${fileName}.csv`;

          document.body.appendChild(link);

          link.dispatchEvent(
            new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            })
          );

          document.body.removeChild(link);
        });
      }
    });
  }
}
